export const LOAD_MENU = 'LOAD_MENU'
export const USER_INFO = 'USER_INFO'
export const GET_INSTITUICOES = 'GET_INSTITUICOES'
